import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=94a88908&scoped=true"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=94a88908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a88908",
  null
  
)

export default component.exports